import { useStateContext } from '@xkit-yx/im-kit-ui'
import { Badge } from 'antd-mobile'
import React, { useEffect, useState } from 'react'
import { redux } from '../../general'
import Manager from '../components/Manager'

export default function Read() {

  const { store, nim } = useStateContext()
  const [allUnread, setAllUnread] = useState()

  useEffect(() => {
    accumulatedUnread()

    nim.on('msg', () => {
      accumulatedUnread()
    })

    redux.subscribe(() => {
      let updateChatUnread = redux.getState().updateChatUnread;
      if (updateChatUnread) {
        accumulatedUnread()
      }
    })

  }, [])

  const accumulatedUnread = () => {
    let unread = 0
    const key = `chat-mute-list-${localStorage.getItem('yx_account')}`
    if (!localStorage.getItem(key)) {
      store.sessionStore.sessions.forEach((session, key) => {
        unread += session.unread
      })
      setAllUnread(unread)
      return
    }
    const sessionStr = localStorage.getItem(key)
    const muteSession = JSON.parse(sessionStr)
    store.sessionStore.sessions.forEach((session, key) => {
      if (!muteSession.includes(session.to)) {
        unread += session.unread
      }
    })
    setAllUnread(unread)
  }

  return (
    <div className='chat-read' onClick={() => {
      Manager.push({event_id:'A-5-11-3'})
      setAllUnread(0)
      redux.dispatch({
        type: 'clearChatUnRead',
        data: {
          clearChatUnRead: true
        }
      })
    }}>
      <Badge content={Badge.dot} wrapperClassName='chat-read-dot' style={{
        '--top': '3px', '--right': '-3px', height: (allUnread > 0 ? '6px' : '0')
      }}>一键已读</Badge>
    </div>
  )
}
